import React from "react";
import { categories } from "../mock";
import useReveal from "../hooks/useReveal";
import useSiteNav from "../hooks/useSiteNav";
import NewsletterDialog from "./NewsletterDialog";
import { ArrowUpRight } from "lucide-react";

const Categories = () => {
  const [ref, visible] = useReveal();
  const { goRoute } = useSiteNav();

  return (
    <section id="topics" className="bg-[#eceae5] pt-6 md:pt-8 pb-20 md:pb-28">
      <div
        ref={ref}
        className={`max-w-[1400px] mx-auto px-6 md:px-10 reveal ${visible ? "is-visible" : ""}`}
      >
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <p className="font-sans-ui uppercase tracking-[0.25em] text-sm text-neutral-500">
              Explore
            </p>
            <h2
              className="font-display text-3xl md:text-5xl text-neutral-900 mt-3 leading-none tracking-tight"
              style={{ fontWeight: 700 }}
            >
              Browse by topic
            </h2>
          </div>
          <button
            onClick={() => goRoute("/topics")}
            className="hidden md:inline-flex items-center gap-2 font-sans-ui text-[15px] text-neutral-900 border border-neutral-400 hover:bg-neutral-900 hover:text-white px-6 py-3 rounded-full transition-all duration-300"
            data-testid="home-view-all-topics"
          >
            View all topics
            <ArrowUpRight size={16} />
          </button>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, i) => (
            <button
              key={cat.name}
              onClick={() => goRoute(`/topics/${cat.slug}`)}
              data-testid={`home-category-${cat.slug}`}
              className="group relative block overflow-hidden rounded-lg text-left"
              style={{
                transition: "opacity 700ms ease, transform 700ms ease",
                transitionDelay: `${i * 90}ms`,
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(28px)",
              }}
            >
              <div className="w-full aspect-[3/4] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <span className="absolute top-4 left-5 font-sans-ui text-sm text-white/70 tracking-[0.2em]">
                0{i + 1}
              </span>
              <span className="absolute top-4 right-5 h-9 w-9 rounded-full border border-white/40 flex items-center justify-center text-white transition-all duration-500 group-hover:bg-white group-hover:text-neutral-900 group-hover:rotate-45">
                <ArrowUpRight size={16} />
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <h3
                  className="font-display text-2xl md:text-[30px] text-white leading-none tracking-tight transition-transform duration-500 group-hover:-translate-y-1"
                  style={{ fontWeight: 700 }}
                >
                  {cat.name.charAt(0) + cat.name.slice(1).toLowerCase()}
                </h3>
                <p className="font-display text-white/80 mt-2.5 leading-snug text-sm">
                  {cat.tagline}
                </p>
              </div>
            </button>
          ))}
        </div>

        <div className="flex justify-center mt-16">
          <NewsletterDialog
            trigger={
              <button className="bg-neutral-900 hover:bg-neutral-700 text-white font-sans-ui text-[15px] px-14 py-5 rounded-full transition-all duration-300 hover:scale-[1.03]">
                Subscribe to our newsletter
              </button>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default Categories;
